
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Où est-il utilisé?`}</em></p>
    <p>{`Il a commencé à être proposé en Russie durant l’automne 2020, avant la
publication des essais cliniques de phase 3. De nombreux pays l’emploient de
façon urgente, comme la Hongrie, le Mexique, l’Argentine, l’Arménie, la
Biélorussie ou la Serbie.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;